import { Box } from "@mui/material";
import type { IPost } from "../types/post";
import type { ISavedRecipes } from "../types/recipe";
import PostCard from "./PostCard";
import SavedRecipe from "./SavedRecipe";

interface ICatalogListDialogProps {
    item: IPost | ISavedRecipes;
    setItem?: any;
    postFollowedOnly?: boolean | undefined;
    dialogType: "post" | "recipe";
}

const CatalogListDialog: React.FC<ICatalogListDialogProps> = ({ dialogType, item, postFollowedOnly, setItem }) => {
    return (
        <Box>
            {dialogType === "post" && <PostCard followedOnly={postFollowedOnly} post={item as IPost} setPost={setItem} />}
            {dialogType === "recipe" && (
                <Box sx={{ p: 2 }}>
                    <SavedRecipe
                        recipeData={item as ISavedRecipes}
                        setRecipeData={setItem as React.Dispatch<React.SetStateAction<ISavedRecipes>>}
                    />
                </Box>
            )}
        </Box>
    );
};

export default CatalogListDialog;
